import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Handshake, Clock, CheckSquare } from 'lucide-react';

const HowItWorksSection: React.FC = () => {
  const navigate = useNavigate();

  const steps = [
    {
      number: 1,
      title: 'Place & Log',
      description: 'Businesses can log orders and customers can view and track their orders',
      icon: Handshake,
      bgColor: 'bg-brand-cream',
    },
    {
      number: 2,
      title: 'Produce & Track',
      description: 'Master Ji offers tracking of orders as well as inventory and other business support',
      icon: Clock,
      bgColor: 'bg-brand-cream',
    },
    {
      number: 3,
      title: 'Receive & Review',
      description: 'Upon completion, customers are able to rate and review tailors.',
      icon: CheckSquare,
      bgColor: 'bg-cream-light',
    },
  ];

  return (
    <section className="bg-white py-16 lg:py-20">
      <div className="max-w-container-lg mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="font-manrope text-body-small text-brand-yellow mb-4"
          >
            How it Works
          </motion.div>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="font-opensans text-display-xl text-text-primary font-bold"
          >
            Simple Process. Powerful Results.
          </motion.h2>
        </div>

        {/* Steps Grid */}
        <div className="grid md:grid-cols-3 gap-8 lg:gap-12 mb-12">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <motion.div
                key={step.number}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="text-center"
              >
                {/* Icon Circle */}
                <div className={`${step.bgColor} w-[172px] h-[172px] rounded-[86px] mx-auto mb-6 flex items-center justify-center`}>
                  <Icon className="w-16 h-16 text-brand-blue" />
                </div>

                {/* Step Title */}
                <h3 className="font-opensans text-heading-2 text-text-primary font-bold mb-4">
                  Step {step.number} | {step.title}
                </h3>

                {/* Description */}
                <p className="font-manrope text-body-medium text-text-dark max-w-[304px] mx-auto">
                  {step.description}
                </p>
              </motion.div>
            );
          })}
        </div>

        {/* CTA Button */}
        <div className="text-center">
          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={() => navigate('/how-it-works')}
            className="border-2 border-brand-blue text-brand-blue font-manrope text-body-large px-8 py-3 rounded-3xl hover:bg-brand-blue hover:text-white transition-all duration-300"
            style={{ minWidth: '236px', height: '52px' }}
          >
            See the Full Workflow
          </motion.button>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;

